export default function acuityHello () {
  return 'Hello Acuity!'
}

global.Acuity.acuityHello = acuityHello
